import { render, staticRenderFns } from "./CommentEditor.vue?vue&type=template&id=6dc4993c&scoped=true&"
import script from "./CommentEditor.vue?vue&type=script&lang=ts&"
export * from "./CommentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommentEditor.vue?vue&type=style&index=0&id=6dc4993c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc4993c",
  null
  
)

export default component.exports